/* __next_internal_client_entry_do_not_use__ withQueryParams auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/ban-types */ import * as React from "react";
import { useMemo } from "react";
import { proxyQueryParams } from "./__internal__/QueryParamsProxy";
import { parseQueryParams } from "./parseQueryParams";
export function withQueryParams(Component, parsingFunction) {
    return function(props) {
        var location = props.location;
        var queryParams = useMemo(function() {
            return parsingFunction ? proxyQueryParams(parsingFunction(location.search)) : parseQueryParams(location.search);
        }, [
            location.search
        ]);
        return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
            queryParams: queryParams
        }));
    };
}
